export default {
    key: "AIzaSyAzdYRjlxKiR2Bp7tQmxusR0hHdccGHErc"
};